enum CompanyUserStatus {
  New,

  Active,

  Terminated,

  Invited,
}
export default CompanyUserStatus
